module.exports = __webpack_public_path__ + "img/eyebrow_female_straight_average_mask.4e33c00d.png";